import React from 'react';

import {ReclaimingInformationCard} from 'components/ais/reclaiming-information-card/reclaiming-information-card';
import {Table} from 'components/table';
import {ITableScroll} from 'components/table/table';
import {EEntityType} from 'shared/constants/entities';

export interface IReclaimingInformationProps {
    url: string;
    hideTitle?: boolean;
    entityType?: EEntityType;
    entityName: string;
    scroll?: ITableScroll;
    entity: string | null;

}

export const ReclaimingInformation = ({
    entity: id, scroll, url, hideTitle, entityType, entityName,
}: IReclaimingInformationProps) => (
    <>
        <Table
            hideTitle={hideTitle}
            entityName={entityName}
            url={url}
            entityType={entityType}
            scroll={scroll}
        />
        {id && (
            <ReclaimingInformationCard
                id={id}
            />
        )}
    </>
);
